import {
  ListItem as MuiListItem,
  ListItemAvatar,
  ListItemButton,
  type ListItemButtonProps,
  ListItemIcon,
  type ListItemProps,
  ListItemSecondaryAction,
  ListItemText,
} from '@mui/material';
import { forwardRef, type PropsWithChildren } from 'react';

interface Props
  extends Pick<ListItemButtonProps, 'onClick' | 'divider' | 'disabled' | 'sx'>,
    Pick<
      ListItemProps,
      | 'component'
      | 'slotProps'
      | 'disablePadding'
      | 'disableGutters'
      | 'onMouseEnter'
      | 'onMouseLeave'
      | 'secondaryAction'
    > {
  button?: boolean;
}

const ListItem = forwardRef<
  HTMLLIElement | HTMLButtonElement,
  PropsWithChildren<Props>
>(({ children, button, onClick, onMouseEnter, onMouseLeave, ...rest }, ref) => {
  if (button) {
    return (
      <ListItemButton
        ref={ref as ListItemButtonProps['ref']}
        onClick={onClick}
        {...rest}
      >
        {children}
      </ListItemButton>
    );
  }
  return (
    <MuiListItem
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      ref={ref as ListItemProps['ref']}
      {...rest}
    >
      {children}
    </MuiListItem>
  );
});

export {
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
};
